import {loadScriptPromise} from "./misc/loadScript";

export const ASYNC_SCRIPTS = {
  html2canvas: "https://d3d4bzhtpt24up.cloudfront.net/shared/js/html2canvas.min.js",
  bundleReactPdf: "https://d3d4bzhtpt24up.cloudfront.net/custom-scripts/bundle-react-pdf.min.js",
  bundleReactPdfRenderer: "https://d3d4bzhtpt24up.cloudfront.net/custom-scripts/bundle-react-pdf-renderer.min.js",
  three: "https://d3d4bzhtpt24up.cloudfront.net/custom-scripts/bundle-three.min.js",
}

export const loadAllAsyncScripts = async () => {
  return await Promise.all([
    ...Object.keys(ASYNC_SCRIPTS).map(scriptName => {
      return loadScriptPromise(ASYNC_SCRIPTS[scriptName], scriptName)
    }),
  ])
}

const _removeElements = (elements) => {
  for (let i = 0; i < elements.length; i++) {
    console.log("removed", elements[i]);
    elements[i].remove();
  }
}

export const removeLoadingElements = (page) => {
  // Get all elements with the specified class "removeOnLoad" which are elements to be removed once the tool is loaded to a point where it can display the tool, and remove them
  const elements = document.getElementsByClassName("removeOnLoad");
  console.log('remove .removeOnLoad classed elements from ' + page, elements);

  if (page !== "Visualizer") {
    _removeElements(elements);
    return
  }

  window.setTimeout(() => {
    _removeElements(elements);
  }, 5000); //delay 5 seconds to allow time for the canvas to render first layer

}

export const runSalesForceLogic = () => {
  if(window.Sfdc && window.Sfdc.canvas && typeof(sr) != 'undefined') {
    console.log("Sfdc available and sr is defined");
    try {
      // Subscribe to a custom event.
      window.Sfdc.canvas(function() {
        window.Sfdc.canvas.client.subscribe(sr.client,
          {name : "quoteCountertops.canvasLoadEvent",
            onData: () => {
              console.log('QC Visualizer received quoteCountertops.canvasLoadEvent');
              window.salesForceLoaded = true;
              window.Sfdc.canvas.client.publish(sr.client, {
                name: "quoteCountertops.canvasOn",
                payload: true
              });
            }});

        window.Sfdc.canvas.client.publish(sr.client, {
          name: "quoteCountertops.canvasReady",
          payload: true
        });

        console.log('sending fake canvasLoadEvent');
        window.Sfdc.canvas.client.publish(sr.client, {
          name: "quoteCountertops.canvasLoadEvent",
          payload: true
        });
      });
    } catch(ex) {
      console.log('SalesForce capable, but not running in salesforce', ex);
    }
  }

  window.addEventListener("message", (event) => {
    // console.log(event);
    if (event.data && event.data.name === "quoteCountertops.canvasLoadEvent") {
      console.log('Message received', event);
      window.sfdcMessage = event.source;
      window.salesForceLoaded = true;
    }
  });
}

export const getMainThemeFromCSS = () => {
  const themeLink = document.querySelector(
    'link[href*="styles-"]:not([href*="styles-look"]):not([href*="styles-loader"])'
  );
  let themeName = null;
  if (themeLink) {
    const match = themeLink.href.match(/styles-([^./]+)\.css/);
    if (match) {
      themeName = match[1]; // "moderno", "nhance", "as"
    }
  }
  return themeName
}
